import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MysqlDatePipe, DateOfBirthPipe } from './custom-date.pipe';
import { CurrencyFormatterPipe } from './currency-formatter/currency-formatter.pipe';
import { TimeDurationFormatterPipe } from './time-duration-formatter/time-duration-formatter.pipe';
import { TicketStatusPipe } from './ticket-status/ticket-status.pipe';

@NgModule({
  declarations: [MysqlDatePipe, DateOfBirthPipe, CurrencyFormatterPipe, TimeDurationFormatterPipe, TicketStatusPipe],
  imports: [
    CommonModule
  ],
  exports: [MysqlDatePipe, DateOfBirthPipe, CurrencyFormatterPipe, TimeDurationFormatterPipe, TicketStatusPipe]
})
export class PipeModule { }
